var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStsBattery(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.2461 22.502H6.24609C4.86484 22.502 3.74609 21.3832 3.74609 20.002V10.002C3.74609 8.6207 4.86484 7.50195 6.24609 7.50195H21.2461C22.6273 7.50195 23.7461 8.6207 23.7461 10.002V20.002C23.7461 21.3832 22.6273 22.502 21.2461 22.502Z",
    stroke: "white",
    strokeWidth: 2.38676,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    d: "M14.125 18.748L16 14.998H11.5L13.375 11.248",
    stroke: "white",
    strokeWidth: 2.38676,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    d: "M23.7539 11.248H25.0214C25.2152 11.248 25.4064 11.293 25.5802 11.3805L26.1877 11.6843C26.6114 11.8955 26.8789 12.3293 26.8789 12.8018V17.1943C26.8789 17.668 26.6114 18.1005 26.1877 18.3118L25.5802 18.6155C25.4064 18.703 25.2152 18.748 25.0214 18.748H23.7539",
    stroke: "white",
    strokeWidth: 2.38676,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStsBattery);
export default __webpack_public_path__ + "static/media/sts_battery.43cbfffb2986d6af84e382ef15d3b64a.svg";
export { ForwardRef as ReactComponent };